import React, { SVGProps } from 'react';

const DiagonalUpArrow = (props: SVGProps<SVGSVGElement>) => {
  const { className, onClick } = props;

  return (
    (<svg
      data-testid="ShManr4gscZAnJf30HGk4"
      className={className}
      onClick={onClick}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 385.756 385.756"
      enableBackground="new 0 0 385.756 385.756"
      data-palette="DiagonalUpArrow">
      <g>
        <g>
          <path
            fill={props?.fill || 'currentColor'}
            d="M377.816,7.492C372.504,2.148,366.088,0,358.608,0H98.544c-15.44,0-29.08,10.988-29.08,26.428v23.724
              c0,15.44,13.64,29.848,29.08,29.848h152.924L8.464,322.08c-5.268,5.272-8.172,11.84-8.176,19.34c0,7.5,2.908,14.296,8.176,19.568
              L25.24,377.64c5.264,5.272,12.296,8.116,19.796,8.116s13.768-2.928,19.036-8.2l241.392-242.172v151.124
              c0,15.444,14.084,29.492,29.52,29.492h23.732c15.432,0,26.752-14.048,26.752-29.492V26.52
              C385.464,19.048,383.144,12.788,377.816,7.492z"
          />
        </g>
      </g>
    </svg>)
  );
};

export default DiagonalUpArrow;
